import React from 'react';
import { Box, IBoxProps, PaddingSize } from '@styleseat/ui';

export type StackProps = Omit<IBoxProps, 'flexDirection'> & {
  space?: PaddingSize,
};

const Stack: React.FC<StackProps> = ({
  children,
  space = 0,
  className = '',
  ...rest
}) => {
  const validChildren = React.Children.toArray(children)
    .filter(child => React.isValidElement(child));
  const childCount = React.Children.count(validChildren);
  return (
    <Box
      {...rest}
      flexDirection="column"
      className={className}
    >
      {React.Children.map(validChildren, (child, index) => (
        <React.Fragment>
          {child}
          {index !== childCount - 1 && !!space && (
            <Box paddingBottom={space} />
          )}
        </React.Fragment>
      ))}
    </Box>
  );
};

export default Stack;
